import * as React from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import useToastPromise from "../../../hooks/useToast";
import { forgotPasswordSchema } from "../../../schemas/forgetPassword";
import { sendForgotPasswordlink } from "../../../services/apiAuth";
import { objectToFormData } from "../../../utils";

export function useForgotPasswordForm() {
  const navigate = useNavigate();
  const [showSuccess, setShowSuccess] = React.useState(false);
  const { showToastPromise } = useToastPromise();

  const methods = useForm({
    resolver: yupResolver(forgotPasswordSchema),
    defaultValues: {},
  });

  const { mutate: requestResetLink, isLoading } = useMutation({
    mutationFn: async (data) => showToastPromise(sendForgotPasswordlink, data),
    onSuccess: () => {
      setShowSuccess(true);
    },
    onError: (error) => {
      console.error("An error occurred while sending reset instructions", error);
    },
  });

  const submitData = React.useCallback(
    (data) => {
      requestResetLink(objectToFormData(data));
    },
    [requestResetLink]
  );

  const handleBackToLogin = React.useCallback(() => {
    navigate("/");
  }, [navigate]);

  const handleFormError = React.useCallback((errors) => {
    console.log(errors);
  }, []);

  return {
    methods,
    showSuccess,
    isLoading,
    submitData,
    handleBackToLogin,
    handleFormError,
  };
}
